export default {
  init() {
    // JavaScript to be fired on all pages

    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
      // Do something else, like open/close menu
      $('body').toggleClass('menu-open');
    });

    $('body').on('click', 'a[href*=\'#\']:not([href=\'#\'],[data-slide=\'prev\'],[data-slide=\'next\'],[data-toggle=\'collapse\'],[data-toggle=\'tab\'],[href=\'#tab\'])', function(e) {
        $('html, body').animate({scrollTop: $( $.attr(this, 'href') ).offset().top - 75}, 500);
        e.preventDefault();
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //

    $('.carousel.multi-slide').on('slide.bs.carousel', function (e) {
        /*
            CC 2.0 License Iatek LLC 2018 - Attribution required
        */
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 9;
        var totalItems = $('.carousel-item').length;

        if (idx >= totalItems-(itemsPerSlide-1)) {
          var it = itemsPerSlide - (totalItems - idx);
          for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction == 'left') {
              $('.carousel-item').eq(i).appendTo('.carousel-inner');
            }else {
              $('.carousel-item').eq(0).appendTo('.carousel-inner');
            }
          }
        }
    });

    $('.carousel').swipe({
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
          if (direction == 'left') $(this).carousel('next');
          if (direction == 'right') $(this).carousel('prev');
          console.log(fingerData);
        },
        allowPageScroll: 'vertical',
    });

    var pageNumber = 1;
    const ajax_posts = window.ajax_posts;

    function load_posts(cat){
        pageNumber++;
        var str = '&pageNumber=' + pageNumber + '&action=more_post_ajax';
        if(cat){
          str += '&cat=' + cat;
        }
        $.ajax({
          type: 'POST',
          dataType: 'html',
          url: ajax_posts.ajaxurl,
          data: str,
          success: function(data){
            var $data = $(data);
            if($data.length){
              $('#ajax-posts').append($data);
              $('#more_posts').attr('disabled',false);
            } else{
              $('#more_posts').attr('disabled',true);
            }
          },
          error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
          },
        });
        return false;
    }

    $('#more_posts').on('click',function(){ // When btn is pressed.
        $('#more_posts').attr('disabled', true); // Disable the button, temp.
        load_posts($(this).data('cat'));
    });

    // restrict past dates for GNR ticket sales
    const gform = window.gform;
    gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
      if ( formId == 2 && fieldId == 9 ) {
          optionsObj.minDate = 0;
      }
      return optionsObj;
    });


    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    const google = window.google;

    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng ),
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    // Render maps on page load.
    $(document).ready(function(){
        $('.acf-map').each(function(){
            initMap( $(this) );
        });
    });


    $('.newsletter-signup').on('click', function(e){
      e.preventDefault();

      $('#newsletterModal').modal('show');
    });

    $('.expand-block-block button').on('click', function(){
      var content = $(this).siblings('.expand-text');
      var button = $(this);

      content.toggleClass('truncate-overflow');
      if(content.hasClass('truncate-overflow')){
        button.html('More <i class="fas fa-caret-down"></i>');
      }else{
        button.html('Close <i class="fas fa-caret-up"></i>');
      }
    })

    $('.open-search-nav a').on('click', function(){
      $('.search-nav').addClass('show');
    });

    $('.carousel-block-block .carousel').on('slide.bs.carousel', function (e) {
      $(this).find('.idx').text(e.to + 1);
    })

    $(document).on('click', '.primary-nav .dropdown-menu', function (e) {
      e.stopPropagation();
    });

    $('.open-search-nav .nav-link').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      document.getElementById('menu-item-dropdown-228').click();
    });

    $('.closenav').on('click', function(){
      $(this).closest('.dropdown').removeClass('show');
      $(this).parent().removeClass('show');
      $('body').removeClass('menu-open');
    })

    $(document).on('click', '.mobile-nav .dropdown-menu.show > .menu-item-has-children > a.dropdown-item', function(e){
      e.preventDefault();
      $(this).attr('aria-expanded', 'true');
      $(this).siblings('.dropdown-menu').addClass('show');
    })

    $('.mobile-nav .dropdown-menu').prepend('<li class="menu-item goback"><a class="dropdown-item"><i class="far fa-angle-left mr-1 d-inline-block"></i> Back</a></li>');

    $('.mobile-nav .goback .dropdown-item').on('click', function(){
      $(this).closest('.dropdown-menu.show').removeClass('show');
    })

    $('.search-nav a').on('click', function(){
      $('body').toggleClass('menu-open');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js